import { Button, Modal, Container } from "react-bootstrap";

const DeleteModal = ({ data, show, setShow, handleDeleteContact }) => {
  const closeModal = () => {
    setShow(false);
  };

  const confirmDelete = () => {
    setShow(false);
    handleDeleteContact();
  };

  return (
    <Container>
      <Modal
        show={show}
        onHide={closeModal}
        centered
        dialogClassName="custom-modal"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
      >
        <Modal.Body style={{ overflowY: "auto" }} className="w-150">
          <div className="mt-4 mb-4 ps-4">
            <h3>Are you sure you want to delete the contact:</h3>
            <h5>{data.name}</h5>
          </div>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={closeModal}
              style={{
                color: "#707782",
                backgroundColor: "#E5E7EB",
                width: "80px",
                border: "none",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={confirmDelete}
              style={{
                color: "#FFFFFF",
                backgroundColor: "#E02827",
                width: "80px",
                border: "none",
              }}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default DeleteModal;
